import { Box, useTheme } from "@vapor/react-material";
import React, { useState, useEffect, useCallback } from "react";

const SCROLL_BOTTOM_THRESHOLD = 100;
const STICKY_FOOTER_HEIGHT = "5rem";
const STICKY_FOOTER_BOTTOM_OFFSET = "1.2rem";

interface StickyFooterProps {
    height?: string;
    width?: string;
    children: React.ReactNode;
}

export const StickyFooter = ({ height, width, children }: StickyFooterProps) => {
    const {
        palette: {
            primary: { textHintColor: ColumbiaBlue }
        }
    } = useTheme();

    const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

    const updateScrollPosition = useCallback(() => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const scrollBottom = scrollTop + windowHeight;

        setIsScrolledToBottom(documentHeight - scrollBottom < SCROLL_BOTTOM_THRESHOLD);
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", updateScrollPosition);
        window.addEventListener("resize", updateScrollPosition);

        updateScrollPosition();

        return () => {
            window.removeEventListener("scroll", updateScrollPosition);
            window.removeEventListener("resize", updateScrollPosition);
        };
    }, [updateScrollPosition]);

    return (
        <>
            <Box
                sx={{
                    height: "2rem",
                    width: "100%"
                }}
            />
            <Box
                sx={{
                    width: width || "100%",
                    height: height || STICKY_FOOTER_HEIGHT,
                    background: "rgb(255, 255, 255)",
                    borderTop: `1px solid ${ColumbiaBlue}`,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    padding: "1rem 3rem",
                    boxSizing: "border-box",
                    position: "fixed",
                    bottom: isScrolledToBottom ? STICKY_FOOTER_BOTTOM_OFFSET : "0",
                    zIndex: "1"
                }}
            >
                {children}
            </Box>
        </>
    );
};
